import { TokenType } from "../../../model/enums/SDKTokenType";
import { TokenGroup } from "../../../model/groups/SDKTokenGroup";
import { v4 as uuidv4 } from "uuid";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Tool implementation
/** Utility for building token trees */
export class DTJSONGroupBuilder {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(versionId, mapping) {
        this.versionId = versionId;
        this.mapping = mapping;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Tree builder
    /** Create mapping between DT <> SN and assign all tokens into their respective newly created groups */
    constructAllDefinableGroupsTrees(processedNodes, brand) {
        // Base mapping function
        const mapping = [
            {
                snType: TokenType.color,
                dtType: "color",
                snRootName: "Color",
                dtRootName: "color",
            },
        ];
        let groups = [];
        mapping.forEach((map) => {
            groups = groups.concat(this.constructGroupTree(processedNodes, map, brand));
        });
        return groups;
    }
    /** Create group tree needed to contain entire token tree for particular mapping combination */
    constructGroupTree(processedNodes, mapping, brand) {
        // Select only nodes with types corresponding to the group
        const nodes = processedNodes.filter((n) => n.token.tokenType === mapping.snType);
        const rootGroup = this.createGroup(brand.id, this.versionId, mapping.snRootName, mapping.snType, true);
        // Set main root group
        const mappedGroups = new Map();
        mappedGroups.set("", rootGroup);
        nodes.forEach((node) => {
            const key = node.path.join(".");
            this.constructGroupChain(this.versionId, brand, mappedGroups, node.path);
            let group = mappedGroups.get(key);
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            group = group.toMutatedObject(group.childrenIds.concat(node.token.id));
            mappedGroups.set(key, group);
        });
        return Array.from(mappedGroups.values());
    }
    constructGroupChain(versionId, brand, groups, path) {
        if (path.length === 0) {
            return;
        }
        // Get parent object
        let parentPath = "";
        let parent = groups.get(parentPath);
        const partialPath = [];
        path.forEach((segment) => {
            partialPath.push(segment);
            const partialKey = partialPath.join(".");
            const object = groups.get(partialKey);
            if (object) {
                // Path exists so we don't do anything else
            }
            else {
                // Path doesn't exist, we create it
                const group = new TokenGroup({
                    brandId: brand.id,
                    tokenType: TokenType.color,
                    designSystemVersionId: versionId,
                    persistentId: uuidv4(),
                    isRoot: false,
                    id: undefined,
                    meta: {
                        name: segment,
                        description: "",
                    },
                    childrenIds: [],
                });
                // Assign to parent
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                parent = parent.toMutatedObject(parent.childrenIds.concat(group.id));
                groups.set(parentPath, parent);
                parent = group;
                // Store group
                groups.set(partialKey, group);
                parentPath = partialKey;
            }
        });
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Group manipulation
    createGroup(brandId, versionId, name, type, isRoot) {
        return new TokenGroup({
            brandId,
            tokenType: type,
            designSystemVersionId: versionId,
            persistentId: uuidv4(),
            isRoot,
            id: undefined,
            meta: {
                name,
                description: "",
            },
            childrenIds: [],
        });
    }
}
